export const HEALTH_INDICATOR_SIZE = 12;
